export enum RoleCode {
  /**
   * 客户经理
   */
  CUSTMANAGER = 'CUSTMANAGER',
  /**
   * 财务稽核
   */
  FINANCEAUDIT = 'FINANCEAUDIT',
  /**
   * 品种经理
   */
  KINDMANAGER = 'KINDMANAGER',
  /**
   * 部门经理
   */
  DEPTMANAGER = 'DEPTMANAGER',
  /**
   * 财务部长
   */
  FINANCEMANAGER = 'FINANCEMANAGER',
  /**
   * 管理层
   */
  LEADER = 'LEADER',
  /**
   * 管理员角色
   */
  SUPERADMIN = 'SUPERADMIN'
}
